import {LossCategory} from "../models/types";
import {useQuery} from "react-query";
import {retrieveLossCategories} from "../restapi/loss-category";
import {ServerError} from "../models/types";

export function useRetrieveLossCategories({onError}: {onError?: (e: ServerError) => void}): LossCategory[] | undefined {
    const lossCategoriesQuery = useQuery(['ReturnReasons'], () => retrieveLossCategories(), {onError: onError});
    return lossCategoriesQuery.data;
}
